import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"justify-center":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{staticClass:"mx-auto",attrs:{"loading":_vm.loading},on:{"loadingStart":function($event){_vm.loading = true},"loadingStop":function($event){_vm.loading = false}}},[_c(VSystemBar,{staticStyle:{"color":"#fff"},attrs:{"dark":"","light":"","color":"blue-grey darken-1"}},[_c(VSpacer),_c('b',[_vm._v("Sistema de control de oficios")]),_c(VSpacer)],1),_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }